import { render, staticRenderFns } from "./Block.vue?vue&type=template&id=320f7058&scoped=true"
import script from "./Block.vue?vue&type=script&lang=ts"
export * from "./Block.vue?vue&type=script&lang=ts"
import style0 from "./Block.vue?vue&type=style&index=0&id=320f7058&prod&lang=scss&scoped=true"
import style1 from "./Block.vue?vue&type=style&index=1&id=320f7058&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320f7058",
  null
  
)

export default component.exports